import { motion } from "framer-motion";

const lineReveal = {
  hidden: { scaleX: 0 },
  visible: {
    scaleX: 1,
    transition: { duration: 0.35, ease: "easeOut" },
  },
};

const SectionEyebrow = ({ children, variants }) => (
  <motion.div variants={variants} className="flex items-center justify-center gap-3">
    <motion.span variants={lineReveal} className="h-px w-7 origin-right bg-[#8B4AFA]/30 sm:w-14" />
    <span className="inline-flex items-center gap-2 whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.16em] text-[#6e3fc7] sm:text-[11px]">
      <span className="h-1.5 w-1.5 rounded-full bg-[#8B4AFA]" />
      {children}
    </span>
    <motion.span variants={lineReveal} className="h-px w-7 origin-left bg-[#8B4AFA]/30 sm:w-14" />
  </motion.div>
);

export default SectionEyebrow;
